import React, { createContext, useCallback, useState, useContext } from 'react';
import { toast } from 'react-toastify';

import codesRepository from '../lib/codes';
import Code from '../dtos/Code';

interface CodeContextData {
  code: Code;
  loading: boolean;
  find(code: string): Promise<void>;
}

const CodeContext = createContext<CodeContextData>({} as CodeContextData);

export const CodeProvider: React.FC = ({ children }) => {
  const [code, setCode] = useState<Code>({} as Code);
  const [loading, setLoading] = useState(false);

  const find = useCallback(async (value: string) => {
    setLoading(true);

    try {
      const data = await codesRepository.find(value);
      setCode(data);
    } catch (err) {
      toast.error('Este código não existe ou não foi encontrado.');
      setCode({} as Code);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <CodeContext.Provider value={{ code, loading, find }}>
      {children}
    </CodeContext.Provider>
  );
};

export function useCode(): CodeContextData {
  return useContext(CodeContext);
}
